export default function WidthWrapper({
  className,
  children,
}: {
  className: string;
  children: React.ReactNode;
}) {
  return (
    <div className={` px-6 lg:px-[42px] xl:px-20  ${className} `}>
      <div className="max-width mx-auto ">{children}</div>
    </div>
  );
}
